'use client'

import React, { FC } from 'react'

import Close from '@/components/svg/Close'
import { cn } from '@/lib/utils'

type Props = {
  open: boolean
  handleClose: () => void
  videoUrl: string
  className?: string
}

const VideoModal: FC<Props> = ({ open, handleClose, videoUrl, className }) => {
  if (!open) return null
  return (
    <div
      className="fixed top-0 left-0 z-1000 flex h-full w-full items-center justify-center
                 bg-black/50 text-white backdrop-blur-sm"
      onClick={handleClose}
    >
      <button
        type="button"
        onClick={handleClose}
        className="fixed top-8 right-8 flex cursor-pointer rounded-full border border-solid text-white"
      >
        <Close width={40} height={40} />
      </button>

      <video
        autoPlay
        muted
        controls
        onClick={(e) => e.stopPropagation()}
        className={cn('h-60 w-80', 'md:h-120 md:w-160', className)}
      >
        <source src={`${videoUrl}.webm`} type="video/webm" />
        <source src={`${videoUrl}.mp4`} type="video/mp4" />
      </video>
    </div>
  )
}

export default VideoModal
